<template>
  <div style="height: 90vh; overflow-y: auto">
    <div class="container" style="max-width: 80rem">
      <div>
        <div class="row">
          <div class="resumeWrapper">
            <div v-if="!haveImage" class="resume-box">
              <div class="col-xl-12 no-padding">
                <div class="dropbox">
                  <form
                    style="height: 100%"
                    enctype="multipart/form-data"
                    novalidate
                  >
                    <div class="row">
                      <input
                        class="input-file"
                        type="file"
                        id="file"
                        ref="file"
                        accept="image/jpg"
                        @change="
                          changePhoto($event.target.name, $event.target.files)
                        "
                      />
                    </div>
                    <div class="form-box">
                      <div class="row justify-content-center">
                        <img src="@/assets/newDesign/resume_new.svg" />
                      </div>
                      <div class="drag">Drag and drop to upload Image</div>
                      <div class="or-text">
                        Or upload news image manually. Size limit 5MB.
                        Supported format png, jpg, jpeg
                      </div>
                      <div class="browse">
                        <div class="btn btn-upload">Browse</div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="image-wrapper">
                <img class="image" :src="changeImgSrc" />
              </div>
              <div
                v-if="haveImage"
                style="margin: 1rem 0 2rem; width: 100%"
                class="btn btn-close"
                @click="removeImage"
              >
                Remove
              </div>
            </div>
          </div>
        </div>
        <v-text-field
          outline
          label="Title"
          v-model="title"
          :error-messages="titleError"
        >
        </v-text-field>
        <v-textarea
          outline
          v-model="description"
          label="Description"
          :error-messages="descriptionError"
        >
        </v-textarea>
        <v-text-field
          outline
          v-model="link"
          label="News Link"
          :error-messages="linkError"
        >
        </v-text-field>
        <v-combobox
          solo
          multiple
          outline
          v-model="tags"
          label="Tags"
          :error-messages="tagsError"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip small>
              <span style="max-width: 40rem; overflow: hidden">{{ item }}</span>
              <v-icon
                color="grey"
                @click="removeTags(index)"
                style="margin-bottom: 0.1rem; margin-left: 0.5rem"
                size="16"
                >cancel</v-icon
              >
            </v-chip>
          </template>
        </v-combobox>
        <div class="horizontal-line" style="background-color: #dcdcdc"></div>
        <div class="row" style="margin: 2rem 0 !important">
          <button class="btn btn-prv-outline" @click="openDialog">
            Preview
          </button>
          <button
            style="margin-left: 1rem"
            class="btn btn-next-outline"
            @click="postNews"
          >
            Post News
          </button>
          <button
            style="margin-left: 1rem; float: right"
            class="btn btn-close"
            @click="cancelNews"
          >
            Cancel
          </button>
        </div>
      </div>
      <div v-if="news_single">
        <v-dialog max-width="100.0rem" v-model="dialog">
          <v-icon
            @click="closeDialog"
            class="icon-class-reject"
            style="float: right"
            >mdi-close</v-icon
          >
          <news-single-view
            :key="change"
            v-bind:newsObj="news_single"
            :preview="preview"
          ></news-single-view>
        </v-dialog>
      </div>
      <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
        <div style="text-align: center; width: 100%">
          <span style="padding-right: 1rem"
            ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
          >{{ snackMessage }}
        </div>
        <!--<v-btn flat :ripple="ripple" @click="snackbar = false">-->
        <!--<v-icon>close</v-icon>-->
        <!--</v-btn>-->
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import NewsSingleView from "../../admin/News/news-single-view";
import { IsEmptyObject } from "../../../globalFunctions";
export default {
  name: "create-news",
  components: {
    NewsSingleView,
  },
  props: {
    news: Object,
  },
  validations: {
    title: {
      maxLength: maxLength(256),
    },
    description: {
      maxLength: maxLength(1024),
    },
    link: {
      maxLength: maxLength(1024),
    },
    tags: {
      maxItems: function () {
        return this.tags.length > 0 && this.tags.length < 11;
      },
    },
  },
  data: function () {
    return {
      title: "",
      description: "",
      link: "",
      changeImgSrc: "",
      tags: [],
      imageFile: null,
      warning: false,
      bgColor: "#454545",
      timeOut: 1000,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false,
      dialog: false,
      news_single: {},
      haveImage:false,
       change: 0,
       preview:true
    };
  },
  methods: {
    cancelNews() {
      this.$emit("cancel");
    },
    removeImage() {
      const self = this;
      self.warning = false;
      self.changeImgSrc = "";
      self.imageFile = null;
      self.haveImage=false
    },
    removeTags(index) {
      const self = this;
      self.tags.splice(index, 1);
    },
    changePhoto(fieldName, fileList) {
      const self = this;
      if (fileList[0].size / 1024 / 1024 > 10) {
        self.warning = true;
        self.haveImage=false
        self.imageFile = null;
      } else {
        self.warning = false;
        self.changeImgSrc = URL.createObjectURL(fileList[0]);
        self.imageFile = fileList[0];
        self.haveImage=true
      }
    },
    postNews() {
      const self = this;
      self.$v.$touch();
      if (!self.$v.$anyError) {
        let formData = new FormData();
        let token = JSON.parse(localStorage.getItem("token"));
        formData.append("lookup_id", self.news.lookup_id);
        if (!!self.imageFile)
          formData.append("file", self.imageFile);
        if (self.title) formData.append("news_title", self.title);
        if (self.description) formData.append("news_desc", self.description);
        if (self.tags.length > 0)
          formData.append("news_tags", JSON.stringify(self.tags));
        if (self.link) formData.append("news_link", self.link);
        self.$http
          .put(self.$constants.BASE_URL.ADMIN_NEWS_MANAGEMENT, formData, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "multipart/form-data",
            },
          })
          .then(function (response) {
            if (response.status === 200) {
              self.snackbar = true;
              self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
              self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
              self.snackMessage = 'Success'; // response.message
              setTimeout(() => {
                self.$emit("posted");
              }, 1000);
            }
          })
          .catch(function (error) {
            self.snackbar = true;
            self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
            self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
            self.snackMessage = error.response.data.description;
          });
      }
    },
    openDialog() {
      const self = this;
      self.$v.$touch();
      if (!self.$v.$anyError) {
        self.news_single = {
          news_title: self.title,
          news_desc: self.description,
          news_link: self.link,
          image_url: self.changeImgSrc,
          news_tags: self.tags,
          post_timestamp: new Date().getTime(),
        };
        self.dialog = true;
        self.change++;
      }
    },
    closeDialog() {
      const self = this;
      self.news_single = {};
      self.dialog = false;
    },
  },
  mounted() {
    const self = this;
    if (!IsEmptyObject(self.news)) {
      self.title = self.news.news_title;
      self.description = self.news.news_desc;
      self.link = self.news.news_link;
      self.changeImgSrc = self.news.image_url;
      self.tags = self.news.news_tags;
      self.haveImage=true
    }
  },
  computed: {
    titleError() {
      const errors = [];
      if (!this.$v.title.$dirty) return errors;
      !this.$v.title.maxLength &&
        errors.push(this.$constants.REQUIRED_MESSAGE.LENGTH_TOO_LONG);
      return errors;
    },
    descriptionError() {
      const errors = [];
      !this.$v.description.maxLength &&
        errors.push(this.$constants.REQUIRED_MESSAGE.LENGTH_TOO_LONG);
      return errors;
    },
    tagsError() {
      const errors = [];
      if (!this.$v.tags.$dirty) return errors;
      !this.$v.tags.maxItems &&
        errors.push(this.$constants.REQUIRED_MESSAGE.NEWS_TAGS);
      return errors;
    },
    linkError() {
      const errors = [];
      if (!this.$v.link.$dirty) return errors;
      !this.$v.link.maxLength &&
        errors.push(this.$constants.REQUIRED_MESSAGE.LENGTH_TOO_LONG);
      return errors;
    },
  },
};
</script>

<style scoped>
.image-wrapper {
  margin: 3rem 0;
}
.image {
  height: auto;
  max-width: 80rem;
}
.resumeWrapper {
  border-radius: 0.8rem;
  width: 100%;
}
.resume-box {
  cursor: pointer;
  margin: 3rem 0;
}
.dropbox {
  width: 100%;
  border-radius: 0.8rem;
  background-color: var(--synop-select-color);
  height: 32.6rem;
  position: relative;
  cursor: pointer;
  border: 0.1rem dashed var(--button-color);
}
@media (max-width: 600px) {
  .dropbox {
    height: 40rem;
  }
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
}
.form-box {
  height: 100%;
  padding: 3rem;
}
.drag {
  font-size: 2.8rem;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;
  color: #050405;
  margin-top: 1.6rem;
}
.or-text {
  font-size: 1.6rem;
  line-height: 1.5;
  text-align: center;
  color: #050505;
  margin-top: 0.8rem;
}
.browse {
  padding: 2rem 0;
  cursor: pointer;
}
</style>